/**
 * @file genericChangeHandler.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since Sep 04, 2021 14:42
 */
import { assertFunc, assertParam } from 'src/@common/asserts';

const handleChange = (event, fieldName, updateFieldValueFunc) => {
    assertParam('event', event);
    assertParam('fieldName', fieldName);
    assertFunc('updateFieldValueFunc', updateFieldValueFunc);

    let str = null;

    if (event) {
        if (event.target.type) {

            switch (event.target.type) {
                case 'autocomplete':
                case 'text':
                    switch (fieldName) {
                        default:
                            if (event.target.value) {
                                str = event.target.value;
                            } else {
                                str = '';
                            }
                            break;
                    }
                    break;

                case 'checkbox':
                    str = event.target.checked;
                    break;

                case 'radio':
                case 'react-select':
                case 'select':
                case 'textarea':
                    str = event.target.value;
                    break;

                default:
                    str = event.target.value;
                    break;
            }

            if (str) {
                // handle any transformations
                switch (fieldName) {
                    case 'geneSymbol':
                        if (str) {
                            if (str.toUpperCase) {
                                str = str.toUpperCase();
                            }
                        }
                        break;

                    default:
                        break;
                }
            }

            // set the updated value in state
            updateFieldValueFunc(fieldName, str);
        }
    }
};

export default handleChange;
